const colors = {
    appBarBackground: '#F8F8F8',
    lightShadow: '#F0F0F0',
    black: '#000000',
    button: '#A5D82A',
    darkGray: '#222222',
    focusedField: '#913DD8',
    main: '#913DD8',
    lightMain: '#C89EEC',
    lighterMain: '#DEC5F3',
    lightBorderGray: '#E1E1E1',
    lightGray: '#F3F0F0',
    lightDarkerGray: '#BFBFBF',
    darkIcon: '#263238',
    labelColor: '#929292',
    lightWarning: 'rgba(255, 0, 0, 0.20)',
    midGray: '#C4C4C4',
    midDarkerGray: '#737373',
    warning: '#FF0000',
    white: '#FFFFFF',
    orderStatusCompleted: '#A5D82A',
    orderStatusNotCompleted: '#BFBFBF',
    orderStatusInProgress: '#BFBFBF',
    orderStatusWarn: '#F2C94C',
    orderStatusError: '#E60000',
}

export default colors
